import { useEffect, useRef } from "react";

import { RADICAL_SAVE_REPORT_MESSAGE_TYPE } from "./creMirrorConstants";

/**
 * R4V host embed — parent posts `{ type: RADICAL_SAVE_REPORT_MESSAGE_TYPE }` into
 * this iframe when the user clicks Save/Submit in R4V (save-on-save). Saves directly
 * without a confirmation modal; no reply is sent back to the parent.
 *
 * @param {() => void | Promise<void>} onSave - Direct save handler (e.g. `handleSave` from Patient.jsx)
 */
export function useRadicalSaveReportMessage(onSave) {
  const onSaveRef = useRef(onSave);
  useEffect(() => {
    onSaveRef.current = onSave;
  }, [onSave]);

  useEffect(() => {
    function onHostSaveReport(event) {
      if (!event?.data || event.data.type !== RADICAL_SAVE_REPORT_MESSAGE_TYPE) {
        return;
      }

      const embedded = window.parent !== window;
      if (embedded) {
        if (event.source !== window.parent) return;
      } else if (event.source !== window) {
        return;
      }

      void onSaveRef.current?.();
    }

    window.addEventListener("message", onHostSaveReport);
    return () => window.removeEventListener("message", onHostSaveReport);
  }, []);
}
